/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSKUs } from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";

export default function SKUSelector({ skus = [], formControlSx }) {
  const dispatch = useDispatch();
  const selectedSKUs = useSelector(
    (state) => state.promoSimulator.selectedSKUs
  );

  useEffect(() => {
    if (selectedSKUs.length > 1) {
      dispatch(setSelectedSKUs([selectedSKUs[0]]));
    }
  }, [selectedSKUs, dispatch]);

  const value = selectedSKUs[0] ?? "";

  const handleChange = (e) => {
    const v = e.target.value;
    dispatch(setSelectedSKUs(v === "" ? [] : [v]));
  };

  return (
    <FormControl fullWidth size="small" disabled={skus.length === 0} sx={formControlSx}>
      <InputLabel>SKU</InputLabel>
      <Select value={value} label="SKU" onChange={handleChange} displayEmpty>
        <MenuItem value="">
          <em></em>
        </MenuItem>
        {skus.map((sku) => (
          <MenuItem key={sku.id} value={sku.id}>
            {sku.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
